import { useNavigate, useParams } from "react-router-dom";

import PageContainer from "../../components/PageContainer";
import { PersonaliseQuoteInputs } from "../../helpers/quotes";
import { useQuotePersonalisation } from "../../hooks/useQuotePersonalisation";
import { useAuth } from "../../providers/AuthProvider";
import QuotePersonaliser from "../components/QuotePersonaliser";

const PersonaliseQuote = () => {
  const { quoteId } = useParams();
  const navigate = useNavigate();
  const { getScopedPageUrl } = useAuth();

  if (!quoteId) {
    // TODO: improve client side error messaging
    throw new Error("quote id param is misisng");
  }

  const {
    control,
    handleSubmit,
    quoteVehicleImages,
    quoteVehicleInfo,
    vehicleOptions,
    isLoading,
    isSuccess,
    isSubmitting,
    hasPricingRequests,
    submitOptions,
    formattedQuote,
  } = useQuotePersonalisation({ quoteId, scope: "all" });

  const onSubmit = async (values: PersonaliseQuoteInputs) => {
    await submitOptions(values);
    navigate(getScopedPageUrl("viewQuote", quoteId));
  };

  const onEdit = async (values: PersonaliseQuoteInputs) => {
    await submitOptions(values);
    navigate(getScopedPageUrl("editQuote", quoteId));
  };

  return (
    <PageContainer title="Vehicle Personalisation" loading={isLoading}>
      {isSuccess &&
        formattedQuote &&
        quoteVehicleInfo.data &&
        vehicleOptions.data && (
          <QuotePersonaliser
            quote={formattedQuote}
            quoteImages={
              quoteVehicleImages.isSuccess ? quoteVehicleImages.data : []
            }
            quoteVehicleInfo={quoteVehicleInfo.data}
            vehicleOptions={vehicleOptions.data}
            control={control}
            handlers={{
              handleEdit: handleSubmit(onEdit),
              handleSubmit: handleSubmit(onSubmit),
            }}
            flags={{
              isSubmitting,
              hasPricingRequests,
            }}
          />
        )}
    </PageContainer>
  );
};

export default PersonaliseQuote;
